export const ANALYTICS_CARD_TYPES = {
  TOTAL_TRANSFERS: 'total_transfers',
  SETTLED: 'settled',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
};

export const TRANSFER_FILTERS_STATUS = {
  ALL_TRANSFERS: 'all',
  SETTLED: 'settled',
  IN_REVIEW: 'in_review',
  INITIATED: 'initiated',
  FAILED: 'failed',
  RETURNED_BY_BANK: 'returned_by_bank',
  ON_ITS_WAY: 'on_its_way',
};

export const TRANSFER_REPORTS_TYPES = {
  ALL_TRANSACTIONS: 'all_transactions',
};
